import React, { useRef, useState } from 'react';
import EmojiInserterEngine from '../../emoji-inserter/EmojiInserterEngine';
import { TextField, Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { ControlPoint } from '@material-ui/icons';
import DescriptionConditionBuilder from '../engine/DescriptionConditionBuilderEngine';
import Animation from '../../../components/Animation';
import { rgba } from 'polished';

import styled from 'styled-components/macro';

const AddLogicBtn = styled(Button)`
  && {
    text-align: left;
    padding: 16px 24px;
    border-radius: 0;
    width: 100%;
    justify-content: start;
    text-transform: none;
    font-weight: 700;
  }
`;

const ActionIconButton = styled(IconButton)`
  && {
    color: #bfc5d1;
    padding: 8px;

    svg {
      font-size: 1.25rem;
    }

    &:hover {
      background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

const TextFieldContainer = styled.div`
  position: relative;
  padding-bottom: 1rem;
  && textarea {
    padding-right: 1rem;
  }
`;

const StyledTooltip = styled(Tooltip)`
  position: absolute !important;
  right: 0;
`;

const EmojiButtonContainer = styled.div`
  position: absolute;
  right: 1rem;
  top: 0;
  && button {
    color #000 !important;
  }
`;

const DescriptionLogicView = props => {
  const { emojiCallback, useMultiDescription } = props;
  const [showEmojiDialog, setShowEmojiDialog] = useState(false);
  const titleRef = useRef(null);

  return (
    <>
      <Animation in={!useMultiDescription} type="collapse">
        <TextFieldContainer>
          <TextField
            data-testid={'simple-description-textarea'}
            multiline
            fullWidth
            rows={5}
            variant="outlined"
            label="Field description"
            placeholder="Type your description here..."
            helperText="Tip: You can add links to your description like this: [Click here](https://google.com)"
            value={props.simpleDescription}
            onChange={e => props.onDescriptionChange(e, 0, true)}
            onBlur={e => props.onDescriptionChange(e, 0, false)}
            inputProps={{ style: { paddingRight: '2rem', resize: 'vertical' } }}
            inputRef={titleRef}
          />
          <EmojiButtonContainer>
            <StyledTooltip title='emoji'>
              <ActionIconButton onClick={() => setShowEmojiDialog(true)}>
                ☺
              </ActionIconButton>
            </StyledTooltip>
          </EmojiButtonContainer>
        </TextFieldContainer>
        <EmojiInserterEngine
          emojiCallback={emojiCallback}
          textInput={titleRef.current}
          text={props.simpleDescription}
          showEmojiDialog={showEmojiDialog}
          setShowEmojiDialog={setShowEmojiDialog}
        />
      </Animation>
      <Animation in={useMultiDescription} type="collapse">
        {props.conditions.map((condition, i) => (
          <DescriptionConditionBuilder
            {...props}
            key={condition._id}
            id={condition._id}
            conditionsStateIndex={i}
            description={condition.description}
            onDescriptionChange={props.onDescriptionChange}
            conditions={condition.conditions}
            dispatch={props.conditionsDispatch}
            conditionsState={props.conditions}
          />
        ))}
      </Animation>
      <AddLogicBtn
        color="primary"
        onClick={props.addCondition}
        startIcon={<ControlPoint />}
      >
        {useMultiDescription ? 'Add new description' : 'Add logic'}
      </AddLogicBtn>
    </>
  );
};

export default DescriptionLogicView;
